import { render } from "./followUpTask.vue?vue&type=template&id=58318747&scoped=true"
import script from "./followUpTask.vue?vue&type=script&lang=js"
export * from "./followUpTask.vue?vue&type=script&lang=js"

import "./followUpTask.vue?vue&type=style&index=0&id=58318747&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58318747"]])

export default __exports__